module.exports = __webpack_public_path__ + "img/ccl_gallery4.71cb2e5f.jpg";